/**
 * @module components\selfcare-raise-complaint\HelpRaiseComplaint
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import store from '@/store';
import { validationMixin } from 'vuelidate';
import { required, maxLength, minLength } from 'vuelidate/lib/validators';
import SelfCareHeading from '@/components/common-components/selfcare-heading/selfcare-heading.vue';
import SelfRaiseTabHeading from '../../common-components/self-raise-tabHeading/self-raise-tabHeading.vue';
import { mapState, mapGetters } from 'vuex';
import RaiseComplaint from '../../../services/api/raise-complaint';
import ResponsePopup from '../../common-components/response-popup/response-popup';
import Raisecomplaint from '../../common-components/raise-complaint-dialog/raise-complaint-dialog';
import _ from 'lodash';
import CategoryConfiguration from '../../../services/api/categoryConfiguration';
import clientDetails from '@/services/api/clientDetails';
import { customPattern } from '@/validations/customPattern';

@Component({
  name: 'HelpRaiseComplaint',
  mixins: [validationMixin],
  components: {
    SelfCareHeading,
    SelfRaiseTabHeading,
    ResponsePopup,
    Raisecomplaint,
  },
  validations :function (this: HelpRaiseComplaint) {
      let validation: any = {
        userDetails: {},
        typeConcern: { required, maxLength: maxLength(512) },
        file: { required },
        typeConcernreq: ['typeConcern'],
        typeConcernreqatt: ['typeConcern', 'file'],
      };
      _.forEach(this.feildDetails,ele => {
         if(ele.fieldValidation != null){
           let element = ele.fieldValidation;
          if (ele.isFieldRequired == 'Y') {
            element.FieldMinLength = element.minLength ? element.minLength.toString(): "";
            element.FieldMaxLength = element.maxLength ? element.maxLength.toString(): "";
            if (
              element.required == true &&
              element.FieldMinLength &&
              element.FieldMaxLength
            ) {
              if (element.pattern) {
                validation.userDetails[ele.fieldName] = {
                  customPattern: customPattern(element.pattern),
                  required,
                  minLength: minLength(element.FieldMinLength),
                  maxLength: maxLength(element.FieldMaxLength)
                };
              } else {
                validation.userDetails[ele.fieldName] = {
                  required,
                  minLength: minLength(element.FieldMinLength),
                  maxLength: maxLength(element.FieldMaxLength)
                };
              }
            } else if (
              element.required != true &&
              element.FieldMinLength &&
              element.FieldMaxLength
            ) {
              validation.userDetails[ele.fieldName] = {
                minLength: minLength(element.FieldMinLength),
                maxLength: maxLength(element.FieldMaxLength)
              };
            } else if (
              element.required != true &&
              !element.FieldMinLength &&
              element.FieldMaxLength
            ) {
              validation.userDetails[ele.fieldName] = {
                maxLength: maxLength(element.FieldMaxLength)
              };
            } else if (
              element.required == true &&
              element.FieldMinLength &&
              !element.FieldMaxLength
            ) {
              validation.userDetails[ele.fieldName] = {
                required,
                minLength: minLength(element.FieldMinLength)
              };
            }else if (
              element.required == true &&
              !element.FieldMinLength &&
              !element.FieldMaxLength
            ) {
              validation.userDetails[ele.fieldName] = {
                required,
              };
            }
            else {
              validation.userDetails[ele.fieldName] = {};
            }
          }
         }
           
      });
      return validation;
    },
  computed: {
    ...mapState(['raiseScreenTitle']),
    ...mapGetters(['TRANSACTIONID']),
  },
})
export default class HelpRaiseComplaint extends Vue {
  /* prop names */
  //@Prop(Boolean) attachmentRequired: boolean | false;
  @Prop(String) pageName: string | undefined;
  @Prop(String) attachmentName: string | undefined;
  @Prop(String) helpTitle: string | null;
  @Prop(String) sub_categories_2: any | null;
  @Prop(String) sub_categories_3: any | null;

  valid = true;
  transactionData = [];
  transErr: string = '';
  postSuccess: boolean = false;
  postErr: boolean = false;
  postCategoryError: string = ' ';
  postCategorySuccess: string = '';
  postResponse = [];
  sectionTitle: string = this.pageName
    ? this.pageName
    : this.$store.state.helpraiseTitle;
  file = null;
  topicName: string = '';
  attachment: boolean = this.$store.state.attachementVal.attachmentRequired
    ? this.$store.state.attachementVal.attachmentRequired
    : false;
  $refs!: {
    file: HTMLFormElement;
  };
  productname: string = null;
  transactionId: number = null;
  subsubCategoryname: string = null;
  subCategoryname: string = null;
  categoryname: string = null;
  typeConcern: string = '';
  btnDisable: boolean = false;
  fieldDisable: boolean = false;
  transactionDisplay: boolean = false;
  querytypeResponse: string = '';
  clientDetailList: any = [];
  uploadLabel: string = this.attachmentName
    ? this.attachmentName
    : 'Upload Screenshot';
  rules = [
    (file) =>
      !file || file.size < 4000000 || 'File size should be less than 4 MB!',
  ];
  transCategory: string = null;
  productRelated: any = this.$store.state.productRelated;
  feildDetails: any = [];
  userDetails: any = {};
  smaDetails = this.$store.state.smaDetails;
  get agentId() {
    return this.$store.state.agentid;
  }
  get mode() {
    return this.$store.state.mode;
  }
  get lang() {
    return this.$store.state.lang;
  }

  /* post the category response */
  async postCategoryList() {
    const formData = new FormData();
    let categoryname;
    this.productname = this.$store.state.levelOneCategory.levelOneEngTitle
      ? this.$store.state.levelOneCategory.levelOneEngTitle
      : null;
    this.transactionId = this.$store.state.transactionId
      ? this.$store.state.transactionId
      : null;
    this.subsubCategoryname = this.$store.state.levelThreeCategory
      .levelThreeEngTitle
      ? this.$store.state.levelThreeCategory.levelThreeEngTitle
      : null;
    this.subCategoryname = this.$store.state.levelTwoCategory.levelTwoEngTitle
      ? this.$store.state.levelTwoCategory.levelTwoEngTitle
      : null;
      let str;
      let userValues = [];
      _.forEach(this.userDetails,ele =>{
          userValues.push(ele);
      });
     if(userValues.length > 0){
       for(let i=userValues.length; i<12; i++){
        userValues.push(null);
       }
     }
     let clientID = null;
     let distributorID = null;
     let smaToken = null;
     if(this.smaDetails && this.smaDetails.agentID){
         clientID = this.smaDetails.agentID;
         distributorID = this.agentId;
         smaToken = this.smaDetails.tokenNumber;
     } else {
       clientID = this.agentId;
     }
    if (this.transactionDisplay) {
      str = JSON.stringify({
        productId: this.productname,
        agentId: clientID,
        transactionId: this.transactionId,
        subCategory: this.subsubCategoryname,
        categoryId: this.subCategoryname,
        typeConcern: this.typeConcern,
        token: token,
        mode: this.mode,
        lang: this.lang,
        userDetails: userValues,
        distributorId: distributorID,
        smaToken:smaToken
      });
    } else if (this.helpTitle) {
      let categoryId = this.helpTitle;
      let subCategoryId = null;
      if (this.sub_categories_2 && this.sub_categories_2.length > 0) {
        categoryId = this.sub_categories_2[0].title;
      }
      if (this.sub_categories_3 && this.sub_categories_3.length > 0) {
        subCategoryId = this.sub_categories_3[0].title;
      }
      str = JSON.stringify({
        productId: this.productRelated ? this.productname : null,
        agentId: clientID,
        transactionId: null,
        subCategory: subCategoryId,
        categoryId: categoryId,
        typeConcern: this.typeConcern,
        token: token,
        mode: this.mode,
        lang: this.lang,
        userDetails: userValues,
        distributorId: distributorID,
        smaToken:smaToken
      });
    } else {
      str = JSON.stringify({
        productId: this.productRelated ? this.productname : null,
        agentId: clientID,
        transactionId: null,
        subCategory: this.subsubCategoryname,
        categoryId: this.subCategoryname,
        typeConcern: this.typeConcern,
        token: token,
        mode: this.mode,
        lang: this.lang,
        userDetails: userValues,
        distributorId: distributorID,
        smaToken:smaToken
      });
    }
    formData.append('raiseComplaint', str);
    formData.append('file', this.file);

     RaiseComplaint.postRaiseComplaint(formData)
       .then((response) => {
         this.postResponse = response.data;
         if (response.status === 200) {
           this.postErr = false;
           this.postSuccess = true;
           this.$v.$reset();
           this.typeConcern = null;
           this.file = null;

           /* setting response on the basis of query parameter */
          let queryType = response.data;
          this.querytypeResponse = queryType.queryType;
          if (
            this.querytypeResponse == 'query' ||
            this.querytypeResponse == 'QUERY'
          ) {
            this.postCategorySuccess = !queryType.responseContent
              ? queryType.complaintResponse
              : queryType.responseContent;
          } else if (
            this.querytypeResponse == 'complaint' ||
            this.querytypeResponse == 'COMPLAINT'
          ) {
            this.postCategorySuccess = queryType.complaintResponse;
          } else {
            this.postCategorySuccess = queryType.complaintResponse;
          }
        }
      })
      .catch((error) => {
        this.postErr = true;
        this.btnDisable = false;
        this.fieldDisable = false;
        this.postCategoryError = error.response.data.message;
        if(this.postCategoryError == "Dear Adhikari,your Token has Expired Please regenerate a token From SMA"){
          this.$store.state.smaDetails = null;
        }
      });
  }

  /* transction data for transaction page */
  async getTransctionData() {
    await RaiseComplaint.getTransactionDetails({
      productName: this.$store.state.levelOneCategory.levelOneCategoryID,
      txnId: this.$store.state.transactionId,
      ticketId: this.$store.state.ticketId,
      mode: this.mode,
      lang: this.lang,
    })
      .then((response) => {
        this.transactionData = response.data;
        store.commit('TRANSACTIONIDVAUE', response.data.txnId);
        this.transCategory =
          response.data.category + ' - ' + response.data.subCategory;
        if (response.status === 200) {
        }
      })
      .catch((error) => {
        this.transErr = error;
      });
  }

  /* getting the value of input file */
  selectFile() {
    this.file = this.$refs.file.files;
  }

  /* on click of submit button */
  submitData() {
    this.$v.$touch();
    let err = true,
      fileErr = true;
    if (this.attachment) {
      if (this.$refs.file.validate()) {
        fileErr = true;
      } else {
        fileErr = false;
      }
    }
    let isCustomFieldsValid = true;
  if(this.$v.userDetails.$invalid){
    isCustomFieldsValid = false;
  }
    if (this.$v.typeConcernreq.$invalid && !this.attachment) {
      err = false;
    } else if (this.$v.typeConcernreqatt.$invalid && this.attachment) {
      err = false;
    } else {
      err = true;
    }

    if (err && fileErr && isCustomFieldsValid) {
      this.postCategoryList();
      this.fieldDisable = true;
      this.btnDisable = true;
    }

    //Google Analytics
    this.$gtag.event('click', {
      event_category: `SelfCare`,
      event_label: 'Help Raise Button Click',
    });
  }
  back() {
    let id = this.$route.name;
    this.$router.beforeEach((to, from, next) => {
      store.commit('setprevRoute', from);
      next();
    });
    this.$router.go(-1);
    //Google Analytics
    this.$gtag.event('click',{
      event_category: `SelfCare`,
      event_label: 'Back Button Click',
    });
  }
  /* mounted function */
  mounted() {  
    CategoryConfiguration.getCategoryConfigurations().then((res) =>{
      let feildsInfo;
      if(res.data && res.data.payload){
        feildsInfo  = res.data.payload.configurationDetails;
      }
            _.forEach( feildsInfo,ele => {
               if(ele.fieldType == 2){
                clientDetails.getClientDetails().then(res =>{
                  if(res && res.data && res.data.payload){
                    this.clientDetailList = this.getClientName(res.data.payload.clientDetails)
                  }
                });
               }
            });
            setTimeout(() => {
              this.feildDetails = feildsInfo;
            },300);
            })
     .catch(err => {
          console.log(err);
     });
      
    if (
      this.$store.state.validMainCategoryIds.includes(
        this.$store.state.mainCategoryInfo.mainCategoryID
      ) &&
      !this.$store.state.notValidSubCategoryIds.includes(
        this.$store.state.levelTwoCategory.levelTwoCategoryID
      )
    ) {
      this.transactionDisplay = true;
      this.getTransctionData();
    }
  }

  //Check this also for Devices
  subCategoryIds = [193, 194, 195, '193', '194', '195'];

  get placeHolderText() {
    if (this.subCategoryIds.includes(this.$store.state.subSubCategoryID)) {
      return 'Please mention your Device Name';
    } else {
      return 'Type your Concern';
    }
  }
  
  getClientName(clientDetails: any) {
    let clientNames = [];
    if (clientDetails && clientDetails.length > 0) {
      _.forEach(clientDetails, ele => {
        clientNames.push(ele.clientName);
        console.log(ele.clientName)
      });
    }
    return clientNames;
  }
}
